// import React, {useState} from 'react';
// import {X} from "lucide-react";
// import {useManageClients} from "../../useManageClients";
//
// const AddClientModal = ({onSubmit}:any) => {
//
//     const {newClient,setNewClient,handleAddClient}=useManageClients()
//
//     const [showAddModal, setShowAddModal] = useState<boolean>(false)
//
//
//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
//                 <div className="p-6 border-b border-gray-200">
//                     <div className="flex items-center justify-between">
//                         <h3 className="text-lg font-semibold text-gray-900">Add New Client</h3>
//                         <button
//                             onClick={() => setShowAddModal(false)}
//                             className="p-2 hover:bg-gray-100 rounded-full"
//                         >
//                             <X className="h-5 w-5 text-gray-400" />
//                         </button>
//                     </div>
//                 </div>
//
//                 <div className="p-6 space-y-6">
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">First Name *</label>
//                             <input
//                                 type="text"
//                                 value={newClient.firstName || ''}
//                                 onChange={(e) => setNewClient({...newClient, firstName: e.target.value})}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">Last Name *</label>
//                             <input
//                                 type="text"
//                                 value={newClient.lastName || ''}
//                                 onChange={(e) => setNewClient({...newClient, lastName: e.target.value})}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                     </div>
//
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">Email Address *</label>
//                             <input
//                                 type="email"
//                                 value={newClient.email || ''}
//                                 onChange={(e) => setNewClient({...newClient, email: e.target.value})}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number *</label>
//                             <input
//                                 type="tel"
//                                 value={newClient.phone || ''}
//                                 onChange={(e) => setNewClient({...newClient, phone: e.target.value})}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                     </div>
//
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">Birthday</label>
//                             <input
//                                 type="date"
//                                 value={newClient.birthday || ''}
//                                 onChange={(e) => setNewClient({...newClient, birthday: e.target.value})}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                     </div>
//
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">Street Address</label>
//                         <input
//                             type="text"
//                             value={newClient.street || ''}
//                             onChange={(e) => setNewClient({...newClient, street: e.target.value})}
//                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                         />
//                     </div>
//
//                     <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">City</label>
//                             <input
//                                 type="text"
//                                 value={newClient.city || ''}
//                                 onChange={(e) => setNewClient({...newClient, city: e.target.value})}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">State</label>
//                             <input
//                                 type="text"
//                                 value={newClient.state || ''}
//                                 onChange={(e) => setNewClient({...newClient, state: e.target.value})}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">ZIP Code</label>
//                             <input
//                                 type="text"
//                                 value={newClient.zipCode || ''}
//                                 onChange={(e) => setNewClient({...newClient, zipCode: e.target.value})}
//                                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             />
//                         </div>
//                     </div>
//
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">Notes</label>
//                         <textarea
//                             rows={3}
//                             value={newClient.notes || ''}
//                             onChange={(e) => setNewClient({...newClient, notes: e.target.value})}
//                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                             placeholder="Add any special notes about this client..."
//                         />
//                     </div>
//                 </div>
//
//                 <div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
//                     <button
//                         onClick={() => setShowAddModal(false)}
//                         className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
//                     >
//                         Cancel
//                     </button>
//                     <button
//                         onClick={handleAddClient}
//                         className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//                     >
//                         Add Client
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };
//
// export default AddClientModal;


import React, { useState } from "react";
import { X } from "lucide-react";
import { PlusIcon } from "@heroicons/react/24/solid";
import Select from "react-select";
import { reactSelectStyles } from "app/subframe";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import {useClientDrawer} from "../drawer/useClientDrawer";
import {DatePicker} from "@nextui-org/react";
import { today, getLocalTimeZone, CalendarDate } from "@internationalized/date";

interface AddClientModalProps {
    setCloseParent?: (isOpen: boolean) => void;
}

const AddClientModal: React.FC<AddClientModalProps> = ({ setCloseParent }) => {
    const {
        onSubmit,
        isCreatingClient,
        profileImagePreview,
        handleProfileImageChange,
        employees,
        setManagerIdsWhenCreating,
    } = useClientDrawer({ setCloseParent });

    const [showAddModal, setShowAddModal] = useState<boolean>(true);

    if (!showAddModal) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="p-6 border-b border-gray-200">
                    <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-gray-900">
                            Add New Client
                        </h3>
                        <button
                            onClick={() => {
                                setShowAddModal(false);
                                setCloseParent?.(false);
                            }}
                            className="p-2 hover:bg-gray-100 rounded-full"
                        >
                            <X className="h-5 w-5 text-gray-400" />
                        </button>
                    </div>
                </div>

                {/* Form */}
                <form onSubmit={onSubmit} className="p-6 space-y-6">
                    {/* Profile Image */}
                    <div className="flex flex-col items-center gap-4">
                        {/*{profileImagePreview ? (*/}
                        {/*    <img*/}
                        {/*        src={profileImagePreview}*/}
                        {/*        alt="Profile Preview"*/}
                        {/*        className="h-[100px] w-[100px] rounded border"*/}
                        {/*    />*/}
                        {/*) : (*/}
                        {/*    <label*/}
                        {/*        htmlFor="profile-upload"*/}
                        {/*        className="flex flex-col gap-3 w-[100px] text-center h-[100px] bg-zinc-100 items-center justify-center border-dashed border-2 p-[10px] rounded cursor-pointer"*/}
                        {/*    >*/}
                        {/*        <PlusIcon className="h-5 w-5 stroke-black" />*/}
                        {/*        <p className="text-sm">Upload Profile</p>*/}
                        {/*    </label>*/}
                        {/*)}*/}
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleProfileImageChange}
                            className="hidden"
                            id="profile-upload"
                            name="profileImage"
                        />
                    </div>

                    {/* First + Last Name */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                First Name *
                            </label>
                            <input
                                type="text"
                                name="firstName"
                                placeholder="Enter first name"
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Last Name *
                            </label>
                            <input
                                type="text"
                                name="lastName"
                                placeholder="Enter last name"
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>
                    </div>

                    {/* Email + Phone */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Email
                            </label>
                            <input
                                type="email"
                                name="email"
                                placeholder="Enter email"
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Phone Number *
                            </label>
                            <PhoneInput
                                containerClass="phone-input-container"
                                inputProps={{ name: "phone" }}
                                specialLabel=""
                                placeholder="+1 (555) 555-5555"
                                inputClass="custom-input !shadow-none hover:!border-neutral-200 w-full"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="flex flex-col gap-2">
                            <label className="text-sm text-neutral-500">
                                Address
                            </label>
                            <input
                                type="text"
                                name="address"
                                placeholder="Enter Address"
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>
                        <div className="flex flex-col gap-2">
                            <label className="text-sm text-neutral-500">
                                DOB
                            </label>
                            <DatePicker
                                maxValue={today(getLocalTimeZone())}
                                name={'dob'}

                            />
                        </div>
                    </div>

                    {/* Gender */}
                    {/*<div>*/}
                    {/*    <label className="block text-sm font-medium text-gray-700 mb-2">*/}
                    {/*        Gender*/}
                    {/*    </label>*/}
                    {/*    <div className="flex gap-4">*/}
                    {/*        <label>*/}
                    {/*            <input type="radio" name="gender" value="female" /> Female*/}
                    {/*        </label>*/}
                    {/*        <label>*/}
                    {/*            <input type="radio" name="gender" value="male" /> Male*/}
                    {/*        </label>*/}
                    {/*        <label>*/}
                    {/*            <input type="radio" name="gender" value="non_binary" defaultChecked /> Non-Binary*/}
                    {/*        </label>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {/* Managers */}
                    {/*<div>*/}
                    {/*    <label className="block text-sm font-medium text-gray-700 mb-2">*/}
                    {/*        Managers*/}
                    {/*    </label>*/}
                    {/*    <Select*/}
                    {/*        isMulti*/}
                    {/*        name="managers"*/}
                    {/*        onChange={(selectedOptions) => {*/}
                    {/*            setManagerIdsWhenCreating(*/}
                    {/*                selectedOptions.map((option: any) => option.value)*/}
                    {/*            );*/}
                    {/*        }}*/}
                    {/*        options={employees.map((emp:any) => ({*/}
                    {/*            value: emp.id,*/}
                    {/*            label: emp.name,*/}
                    {/*        }))}*/}
                    {/*        className="text-sm"*/}
                    {/*        classNamePrefix="select"*/}
                    {/*        styles={reactSelectStyles({})}*/}
                    {/*    />*/}
                    {/*</div>*/}

                    {/* Notes */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Notes
                        </label>
                        <textarea
                            rows={3}
                            name="notes"
                            placeholder="Enter notes..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end space-x-3 border-t border-gray-200 pt-4">
                        <button
                            type="button"
                            onClick={() => {
                                setShowAddModal(false);
                                setCloseParent?.(false);
                            }}
                            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isCreatingClient}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                        >
                            {isCreatingClient ? "Adding..." : "Add Client"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddClientModal;
